import HardwareVersionEditor from './hardware-version-editor';

export default HardwareVersionEditor;